import useInteractiveWidgetSubmit from '../../hooks/useInteractiveWidgetSubmit';
import {
  buildCampaignTypeCompletionMessage,
  CAMPAIGN_TYPE_UI_TOOL_NAME,
} from '../../domain/campaignToolCatalog';
import CampaignTypeSelector from '../CampaignTypeSelector';

export default function CampaignTypeIntegration({
  selectedValue = null,
  isReadOnly = false,
  toolCallId = null,
}) {
  const {handleSubmit: handleSelect, isPending} = useInteractiveWidgetSubmit(
    CAMPAIGN_TYPE_UI_TOOL_NAME,
    toolCallId,
    (data) =>
      buildCampaignTypeCompletionMessage(
        data.selectedValue || data.value || 'NONE',
      ),
  );

  return (
    <CampaignTypeSelector
      selectedValue={selectedValue}
      isReadOnly={isReadOnly || isPending}
      onSelect={(value) => {
        if (isReadOnly || isPending) {
          return;
        }
        handleSelect({selectedValue: value});
      }}
    />
  );
}
